import { c as _c } from "react/compiler-runtime";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { applicationStore, LoginStatus } from "@website/store/store";
import { useWebengage } from "@website/tracking/tracking.webengage.hook";
import { getChannel } from "@website/utils/channel/get-channel";
import { setChannel } from "@website/utils/channel/set-channel";
import toString from "lodash-es/toString";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { convertToken, useAuthSessionRefresh, useLoginStatus } from "./utils";
setChannel();
export const useAuth = () => {
  const $ = _c(20);
  const searchParameters = useSearchParams();
  const {
    loginStatus
  } = useLoginStatus();
  const pathName = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getChannel();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentChannel = t0;
  let t1;
  if ($[1] !== searchParameters) {
    t1 = toString(searchParameters?.get("ispwa"));
    $[1] = searchParameters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isPwa = t1;
  let t2;
  if ($[3] !== searchParameters) {
    t2 = toString(searchParameters?.get("app_version"));
    $[3] = searchParameters;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const appVersion = t2;
  let t3;
  if ($[5] !== searchParameters) {
    t3 = toString(searchParameters?.get("token"));
    $[5] = searchParameters;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const queryToken = t3;
  let t4;
  if ($[7] !== searchParameters) {
    t4 = searchParameters?.toString() || "";
    $[7] = searchParameters;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const searchParametersKey = t4;
  useConvertToken();
  const t5 = `${pathName || ""}?${searchParametersKey}`;
  let t6;
  if ($[9] !== queryToken || $[10] !== t5) {
    t6 = {
      routeChangeKey: t5,
      queryToken
    };
    $[9] = queryToken;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useAuthSessionRefresh(t6);
  let t7;
  let t8;
  if ($[12] !== appVersion || $[13] !== isPwa) {
    t7 = () => {
      if (isPwa) {
        applicationStore.applicationData.isPwa.set(isPwa === "true");
      }
      if (appVersion) {
        applicationStore.applicationData.appVersion.set(appVersion);
      }
    };
    t8 = [isPwa, appVersion];
    $[12] = appVersion;
    $[13] = isPwa;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[16] !== loginStatus || $[17] !== pathName) {
    t9 = () => {
      const channel = getChannel();
      const channelHasRedirectState = channel === "b2b" || channel === "telesale";
      if (channelHasRedirectState && loginStatus === LoginStatus.LoggedOut && pathName !== "/b2b-login") {
        window.location.href = "/b2b-login";
      }
    };
    t10 = [loginStatus, pathName, currentChannel];
    $[16] = loginStatus;
    $[17] = pathName;
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
};
export const useConvertToken = () => {
  const $ = _c(11);
  const searchParameters = useSearchParams();
  const {
    login
  } = useWebengage();
  let t0;
  if ($[0] !== searchParameters) {
    t0 = toString(searchParameters.get("token"));
    $[0] = searchParameters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryToken = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getChannel();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryToken) {
    t2 = ["auth-cookie", "convert-token", t1, queryToken];
    $[3] = queryToken;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== login || $[6] !== queryToken) {
    t3 = async () => {
      await convertToken(queryToken, login);
    };
    $[5] = login;
    $[6] = queryToken;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      queryKey: t2,
      enabled: true,
      queryFn: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useFetcherV2(t4);
};